import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'New and improved<br />{token} is available!',
    balance:
      'Current balance <b>{amount} {token}</b> (deprecated version).<br />To continue earning rewards and ensure compatibility, please:',
    note: 'This will upgrade your tokens to the latest supported version.',
    unstakeOldToken: 'Unstake your old {token} tokens',
  },
};
